const imp = () => import(/* webpackChunkName: "ui_commont_icon"*/  "../sprite/loadSprite_invoiceCloud");
const loadMap_invoiceCloud: { [key: string]: () => Promise<any> } = {
  "Icon-Oil-supplement": imp,
  "Icon-Meal-supplement": imp,
  "Icon-aircraft": imp,
  "Icon-communication": imp,
  "Icon-to-work-in-an-office": imp,
  "Icon-get-accommodation": imp,
  "Icon-bus": imp,
  "Icon-traffic": imp,
  "Icon-train": imp,
  "Icon-Business-entertainment": imp,
}
export default loadMap_invoiceCloud;